import React from "react";
import connect from "../../../i18n/connect";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import withStyles from "@mui/styles/withStyles";
import { withFormsy } from "formsy-react";
import FormsyBase, { styles } from "./FormsyBase";

@connect()
@withFormsy
@withStyles(styles)
class FormsySelect extends FormsyBase {
  static defaultProps = {
    showInitialValue: false
  };

  render() {
    let {
      classes,

      name,
      label,
      options,
      fullWidth,

      errorMessage,
      value,
      translate,
      showInitialValue,
      disabled
    } = this.props;

    const showError = this.showError();
    label = translate(label);

    return (
      <FormControl
        className={classes.formControl}
        error={showError}
        fullWidth={fullWidth}
        size={"small"}
      >
        <InputLabel htmlFor={name} variant="standard">
          {label}
        </InputLabel>
        <Select
          value={value || ""}
          inputProps={{
            name: name
          }}
          onChange={event => this.handleChange(event.target.value)}
          disabled={disabled}
          variant="standard"
        >
          {showInitialValue ? <MenuItem value="">{label}</MenuItem> : null}
          {options
            ? options.map(option => (
                <MenuItem value={`${option.value}`} key={option.value}>
                  {option.label}
                </MenuItem>
              ))
            : null}
        </Select>
        {showError ? (
          <FormHelperText>{translate(errorMessage)}</FormHelperText>
        ) : null}
      </FormControl>
    );
  }
}

export default FormsySelect;
